<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-22 11:44:44
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-22 14:06:06
 * @FilePath: /privacy-web/src/views/PrivacyAttestation/ProblemFeedback.vue
-->
<template>
  <div
    class="Problem-feedback-main"
    :class="{ 'Problem-feedback-main-mobile': isMobile }"
  >
    <Base-title title="联系贝壳隐私合规团队"></Base-title>
    <FeedbackType></FeedbackType>
  </div>
</template>
<script>
export default {
  // 隐私问题反馈
  name: "ProblemFeedback",
};
</script>
<style lang="scss" scoped>
.Problem-feedback-main {
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
  margin: auto;
  padding-top: calc($multiple * 78px);
  width: calc($multiple * 1040px);
  height: calc($multiple * 633px);
  flex-direction: column;
}

.Problem-feedback-main-mobile {
  padding-top: 2.1rem;
  padding-bottom: 2.51rem;
  width: auto;
  height: auto;
}
</style>
